import { SvgIcon } from "@mui/material";
import "./ScrollIndicator.css";
import { useEffect, useState } from "react";

export default function ScrollIndicator() {
  const [show, setShow] = useState<boolean>(false);

  const showDelayed = () => {
    const main = document.getElementsByTagName("main")[0];
    setTimeout(() => main.scrollTop === 0 && setShow(true), 3000);
  };

  useEffect(() => {
    showDelayed();
  }, []);

  useEffect(() => {
    const main = document.getElementsByTagName("main")[0];
    const handleScroll = () => {
      if (main.scrollTop === 0) {
        showDelayed();
      } else {
        setShow(false);
      }
    };
    main.addEventListener("scroll", handleScroll, true);
    return () => {
      main.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  return (
    <div id="scroll-indicator" className={show ? "show" : ""}>
      <ScrollIndicatorIcon />
    </div>
  );
}

function ScrollIndicatorIcon() {
  return (
    <SvgIcon sx={{ fontSize: 40 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#e8eaed"
      >
        <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
      </svg>
    </SvgIcon>
  );
}
